export enum LiquidSenseContentType {
  FirstSweep = 'First Transfer',
  UpcomingExpensesExceedCash = 'Upcoming Expenses Exceed Cash',
  BuildReserve = 'Build Reserve',
  ConnectAccounts = 'Connect Accounts',
}
